import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  searchableSelectButton: {
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '0.25rem',
    fontWeight: 400,
    padding: theme.spacing(0.5, 1.5, 0.5, 1),
    minHeight: '2rem',
    span: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      maxWidth: '12rem'
    },
    '.MuiButton-endIcon': {
      marginLeft: theme.spacing(0.25)
    }
  },
  searchableSelectCheckbox: {
    minWidth: '2rem'
  },
  searchableSelectFooter: {
    borderTop: `1px solid ${theme.vars.palette.border.light}`,
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '0.5rem'
  },
  searchableSelectList: {
    minWidth: '15rem',
    '.MuiCheckbox-root': {
      padding: theme.spacing(0.5, 1)
    },
    '.with-secondary .MuiListItemButton-root': {
      paddingRight: '5rem !important'
    }
  },
  searchableSelectListItemAvatar: {
    display: 'flex',
    borderRadius: '50%',
    marginRight: theme.spacing(1),
    minWidth: 0,
    '& > .MuiAvatar-circular': {
      backgroundColor: theme.vars.palette.transparent.a10,
      border: `1px solid ${theme.vars.palette.border.light}`,
      color: theme.vars.palette.transparent.a50,
      height: '1.75rem',
      width: '1.75rem'
    }
  },
  searchableSelectListItemText: {
    '& .MuiTypography-body1': {
      color: theme.vars.palette.text.primary
    },
    '& .MuiTypography-body2': {
      color: theme.vars.palette.transparent.a50
    }
  },
  searchableSelectListItemTextWarning: {
    '& .MuiTypography-body1': {
      color: theme.vars.palette.warning.main
    },
    '& .MuiTypography-body2': {
      color: theme.vars.palette.transparent.a50
    }
  },
  searchableSelectListSubheader: {
    backgroundColor: theme.vars.palette.transparent.a10,
    fontSize: '1rem',
    borderBottom: `1px solid ${theme.vars.palette.border.light}`,
    lineHeight: '2.5rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    button: {
      marginRight: '-0.25rem'
    }
  },
  searchableSelectSearch: {
    borderBottom: `1px solid ${theme.vars.palette.border.light}`,
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1)
  },
  buttonGroup: {
    minHeight: '2rem',
    '.MuiButton-root': {
      padding: theme.spacing(0.5, 1.25, 0.5, 1)
    }
  }
}));

export default useStyles;
